import { api } from '@dpgradio/creative'

let consentQuestion = null

export async function getConsentQuestion() {
  if (consentQuestion) {
    return consentQuestion
  }
  const { question } = await api.request().get('crm_consent/question')
  consentQuestion = question
  return question
}

export async function pushConsent(email) {
  await api.request().post('crm_consent/subscribe', {
    email: email,
    question: consentQuestion,
    touchpoint_url: window.location.href,
  })
}
